import React from "react";
import "../printStyles.css";

function FinesInfringementsLog() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #FinesInfringementsLogForm, #FinesInfringementsLogForm * {
              visibility: visible;
            }
            #FinesInfringementsLogForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="FinesInfringementsLogForm" className="p-4 border rounded-lg bg-white shadow-md">
        <h3 className="text-2xl font-semibold mb-4">Fines & Infringements Log</h3>

        <form>
          {/* Log Created By */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="logCreatedBy">
              Log Created By (Name):
            </label>
            <input
              type="text"
              id="logCreatedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Vehicle Registration (if applicable) */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="vehicleRegistration">
              Vehicle Registration (if applicable):
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Date of Offence */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="dateOfOffence">
              Date of Offence:
            </label>
            <input
              type="date"
              id="dateOfOffence"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Driver Name */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="driverName">
              Driver Name:
            </label>
            <input
              type="text"
              id="driverName"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter driver name"
            />
          </div>

          {/* Infringement Type */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="infringementType">
              Infringement Type:
            </label>
            <div className="space-y-4">
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Speeding</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Parking</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                <span className="text-sm">Other</span>
              </label>
            </div>
          </div>

          {/* Fine Amount */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="fineAmount">
              Fine Amount:
            </label>
            <input
              type="number"
              id="fineAmount"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter fine amount"
            />
          </div>

          {/* Status */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="status">
              Status:
            </label>
            <div className="flex space-x-4">
              <label className="flex items-center space-x-1">
                <input type="radio" name="status" value="Paid" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Paid</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="status" value="Pending" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Pending</span>
              </label>
            </div>
          </div>

          {/* Overall Review */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="overallReview">
              Overall Review:
            </label>
            <div className="flex space-x-4">
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallReview" value="Cleared" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">All Cleared</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="overallReview" value="PendingActions" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Pending Actions</span>
              </label>
            </div>
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Record any other details, like dates paid or appeal status"
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default FinesInfringementsLog;
